import React from 'react'
import PropTypes from 'prop-types'
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3'
import { getConfigDetails } from '../../services/config'

const RecaptchaWrapper = ({ children }) => {
    const siteKey = getConfigDetails()?.recaptchaSiteKey

    if (!siteKey) {
        console.error('[reCAPTCHA] REACT_APP_RECAPTCHA_SITE_KEY is missing in env')
        return <>{children}</>
    }

    return (
        <GoogleReCaptchaProvider
            reCaptchaKey={siteKey}
            scriptProps={{
                async: true,
                defer: true,
                appendTo: 'head',
            }}
        >
            {children}
        </GoogleReCaptchaProvider>
    )
}

RecaptchaWrapper.propTypes = {
    children: PropTypes.node.isRequired,
}

export default RecaptchaWrapper